export const customClaims = {
  printOfficeId: 'printOfficeId',
};
